import { useEffect, useState } from 'react';
import { CSSTransition } from 'react-transition-group';

import { Text } from '~/components/ui/Text';
import { useWalletIcon } from '~/hooks';
import { rage, useObservable } from '~/rage';
import { Currency, WalletType } from '~/shared';
import { IconStroke } from '../IconStroke';
import { TabButton } from '../TabButton';
import { XPProgressBar } from '../XPProgressBar';
import {
	StyledContainer,
	StyledMoneyDeposit,
	StyledStatContainer,
	StyledStatsContainer,
	StyledXPContainer,
} from './PlayerStats.styled';

const PlayerStats: React.FC = () => {
	const moneyStart = rage.bank.getBalance(WalletType.Cash).getValue();
	const money = useObservable(rage.bank.getBalance(WalletType.Cash));
	const moneyDiff = useObservable(rage.bank.getBalanceDiff(WalletType.Cash));
	const [moneyVisible, setMoneyVisible] = useState(false);

	const rubleIcon = useWalletIcon(Currency.Ruble, true);

	useEffect(() => {
		if (moneyDiff !== 0) {
			setMoneyVisible(true);

			const timer = setTimeout(() => {
				setMoneyVisible(false);
			}, 5000);

			return () => clearTimeout(timer);
		}
	}, [moneyDiff]);

	useEffect(() => {
		return () => {
			rage.bank.finishDisplayingBalanceDiff(WalletType.Cash);
		};
	}, []);

	return (
		<StyledContainer>
			<StyledStatsContainer>
				<StyledStatContainer>
					<IconStroke src={rubleIcon!} width={14} height={14} />
					<Text
						style={{
							fontWeight: 700,
							fontSize: '20px',
							color: '#ffffff',
							textShadow: '1px 1px 0px #000000',
						}}
					>
						{(money ?? moneyStart).toLocaleString('ru-RU')}
					</Text>
					<CSSTransition
						in={moneyVisible}
						classNames="fade"
						timeout={500}
						unmountOnExit
						onExited={() =>
							rage.bank.finishDisplayingBalanceDiff(WalletType.Cash)
						}
					>
						<StyledMoneyDeposit $negative={moneyDiff < 0}>
							{moneyDiff > 0
								? `+ ${moneyDiff.toLocaleString('ru-RU')}`
								: `- ${Math.abs(moneyDiff).toLocaleString('ru-RU')}`}
						</StyledMoneyDeposit>
					</CSSTransition>
				</StyledStatContainer>
			</StyledStatsContainer>
			<StyledXPContainer>
				<TabButton>TAB</TabButton>
				<XPProgressBar />
			</StyledXPContainer>
		</StyledContainer>
	);
};

export { PlayerStats };
